// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader{display:flex;justify-content:center;align-items:center;height:100%}
`, "",{"version":3,"sources":["webpack://./app/_react_/states/multipartyDashboard/multipartyDashboard.scss"],"names":[],"mappings":"AAAA,QACI,YAAa,CACb,sBAAuB,CACvB,kBAAmB,CACnB,WAAY","sourcesContent":[".loader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
